import { Typography } from "@mui/material";

import StyledProPage from "features/Auth/Onboarding/ProOnboarding/StyledPage";

interface Props {
  handleNext: () => void;
  handleBack?: () => void;
  nextLoading?: boolean;
}

const AutopilotOnboardingCompleteScreen = ({
  handleNext,
  handleBack,
  nextLoading,
}: Props) => {
  return (
    <StyledProPage
      stepNumber={7}
      stepLabel="Finished"
      title="You're All Set!"
      description={
        <>
          <Typography sx={{ fontSize: { xs: 13, md: 18 }, my: 3 }}>
            Bento Autopilot will start finding and pitching brands for you
            automatically. Sit back and let the partnerships come to you.
          </Typography>
        </>
      }
      body={<></>}
      onNext={handleNext}
      onBack={handleBack}
      buttonNext="Go to Dashboard"
      buttonBack="Back"
      splitScreen={false}
      loading={nextLoading}
    />
  );
};
export default AutopilotOnboardingCompleteScreen;
